import { SignatureFormat } from '../signature-types';
import { decodeDataUrl } from './data-url';
export const isExternalImage = value => {
  const dataURL = decodeDataUrl(value.url);
  if (!dataURL) {
    return true;
  }
  return dataURL.mimeType !== SignatureFormat.POINTS && dataURL.mimeType !== SignatureFormat.TEXT;
};
export const getColor = (compId, cssVariable) => {
  if (typeof window === 'undefined' || !cssVariable) {
    return;
  }
  const dataHook = `[id=${compId}] [data-hook="form-root"]`;
  const element = document.querySelector(dataHook);
  const color = element ? getComputedStyle(element).getPropertyValue(cssVariable) : undefined;
  return color;
};
//# sourceMappingURL=drawer.js.map